export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBMOOuZw-nVmwU-cKACCf2PuTmimtIKAfY',
    authDomain: 'fact-check-trump-dev.firebaseapp.com',
    projectId: 'fact-check-trump-dev',
    storageBucket: 'fact-check-trump-dev.firebasestorage.app',
    messagingSenderId: '188371550784',
    appId: '1:188371550784:web:89901045b760108cfa95a5',
    measurementId: 'G-GH7Y0YVE26',
  },
  recaptchaSiteKey: '', // Not required in dev, but must exist for type safety
  useFactsApi: true,
  apiBaseUrl: '/api',
};
